import React from "react";
import { Text } from "@chakra-ui/react";
import { Table } from "components";
import { useUpdatePostAnestheticVital } from "./duck";

interface TableCellProps {
  record: any;
  cellName: string;
  cellType?: "number" | "text";
}

const TableCell: React.FC<TableCellProps> = ({
  record,
  cellName,
  cellType = "number"
}) => {
  const onBlur = useUpdatePostAnestheticVital();

  return record.isEditable ? (
    <>
      {cellType === "number" && (
        <Table.NumberInput
          defaultValue={record.value}
          onBlur={newValue =>
            onBlur(
              newValue,
              record.record._id || record.record.fakeId,
              cellName
            )
          }
        />
      )}
      {cellType === "text" && (
        <Table.TextInput
          defaultValue={record.value}
          onBlur={newValue =>
            onBlur(
              newValue,
              record.record._id || record.record.fakeId,
              cellName
            )
          }
        />
      )}
    </>
  ) : (
    <Text whiteSpace="normal">{record.value}</Text>
  );
};

export default TableCell;
